import { Fragment } from 'react';

import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';
import { StyledBackground } from './Background.styled';

const Background = () => (
	<Fragment>
		{rage.config.isStub() && (
			<BgPlaceholder $type={PlaceholderType.DefaultNight} />
		)}
		<StyledBackground />
	</Fragment>
);

export { Background };
